<template>
  <div class="game-rules-download-modal" v-if="isVisible" @click.prevent="onBGClick">
    <div class="game-rules-download-modal-content" @click.stop="">
      <div class="title">Download Game Rules</div>
      <div class="market">
        <div class="market-select-title">Select market</div>
        <SearchFormSelect :options="marketOptions" v-model="selectedMarket"
          @update:model-value="(value) => onMarketUpdate(value)" />
      </div>
      <div class="download-button">
        <a :href="documentURL" target="_blank">
          <button type="button" class="page-button-2" @click="onDownloadBtnClick">
            <span></span><span>Download</span><span></span>
          </button>
        </a>
      </div>
    </div>
  </div>
</template>


<script>
import SearchFormSelect from "@/components/forms/search-form-select";

export default {
  name: "GameRulesDocumentDownloadModal",

  components: {
    SearchFormSelect,
  },

  props: {
    markets: Array,
    gameName: String,
    isVisible: Boolean,
  },

  events: ['close'],

  data() {
    return {
      selectedMarket: '',
      documentURL: '',
    }
  },

  computed: {
    marketOptions() {
      const options = this.markets.map((i) => ({ title: i.market_name, value: i.market_name }));
      return options;
    },
  },

  methods: {
    onMarketUpdate(value) {
      const market = this.markets.filter((i) => i.market_name === this.selectedMarket)[0];
      if (!market) {
        return '';
      }

      const url = `/api/v1/games/${this.gameName}/game_rules/download/?market=${market.market_code}`;
      this.documentURL = url;
    },
    onBGClick() {
      this.$emit('close');
    },
  }
}
</script>

<style lang="scss"></style>
